import React from 'react'
import ConfettiDisplay from '../components/Coins'

export default function CustomerCoins() {
  return (
    <div className='container mx-auto'>
        <ConfettiDisplay/>
    </div>
  )
}
